The scheme ID of the event.

Currently, only `seekAnz` and `seekAnzPublicTest` are supported.
